import React, { FC, useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import _ from 'lodash';

import Popup from '../../containers/Popup';
// eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/ban-ts-ignore
// @ts-ignore
// import UserListHeader from '../../containers/UserListHeader';
// eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/ban-ts-ignore
// @ts-ignore
// import KanaList from '../../containers/KanaList';
import UserInputMoffRaku from '../../containers/UserInputMoffRaku';
import { MENU_TYPE } from '../../constants/Menu';
import PageLoader from '../Atoms/PageLoader';

interface UserSelectMoffRakuProps {
  moffAPI: any;
}

interface Snapshot {
  users?: any;
  icd10?: any;
  disease?: any;
}

const MoffRakuUsers: FC<UserSelectMoffRakuProps> = ({ moffAPI }) => {
  // #834 C 修正: PUT 保存中に apiRequestFunc が LOADING action を dispatch して
  // moffAPI.Loaded=false にするたびに UserInputMoffRaku が unmount → 再マウントされ、
  // 内部の useRef (hasLoadedDataRef, dirtyCells, jspreadsheet インスタンス, 自動保存設定 等)
  // が全部リセットされて redirect useEffect が暴発しページがリロードされていた。
  // ここで result の users / icd10 / disease をローカルにキャッシュし、PUT 後 result が
  // 空に置換されても直近値を維持して UserInputMoffRaku を mount し続ける。
  const [snapshot, setSnapshot] = useState<Snapshot>({});

  useEffect(() => {
    setSnapshot((prev) => ({
      users: !_.isEmpty(moffAPI.result.users) ? moffAPI.result.users : prev.users,
      icd10: !_.isEmpty(moffAPI.result.icd10) ? moffAPI.result.icd10 : prev.icd10,
      disease: !_.isEmpty(moffAPI.result.disease) ? moffAPI.result.disease : prev.disease,
    }));
  }, [moffAPI.result]);

  const hasInitialData = snapshot.users !== undefined;

  return (
    <Box>
      <Popup />
      {/* 初回ロード前のみフルローダーを表示。保存中は表を維持し、自動保存トグル側の状態表示に任せる */}
      {!hasInitialData && !moffAPI.Loaded && <PageLoader />}
      {hasInitialData ? (
        <UserInputMoffRaku
          type={MENU_TYPE.MoffRakuUsers}
          users={snapshot.users}
          // users_basicinfo={moffAPI.result.usersBasicInfo}
          icd10={snapshot.icd10}
          disease={snapshot.disease}
        />
      ) : null}
    </Box>
  );
};

export default MoffRakuUsers;
